import { AxiosRequestConfig } from "axios";
import { hasPermission } from "components/permissionsGate";
import ApiService from "utils/api/api-service";
import ApiResponse, { isError } from "utils/api/models/api-response";
import { ApiErrorNotification } from "utils/ui/notificationService";
import { CompanyModel } from "models/companies";

class SearchService extends ApiService {
  constructor(config?: AxiosRequestConfig) {
    super({
      baseURL: process.env.REACT_APP_API_URL,
      ...config,
    });
  }
  public async FetchClients(
    search: string,
  ): Promise<ApiResponse<any>> {
    return this.get(
      `/api/search/?q=${search}`
    );
  }
}

const searchService = new SearchService();
export const FetchSearchClient = async (
  search: string,
) => {
  if (hasPermission(["browse_users"])) {
    const result: any = await searchService.FetchClients(search);
    if (isError(result)) {
      ApiErrorNotification(result);
      throw result;
    } else {
      return result;
    }
  }
};
